import * as yup from "yup";

export const contentPrivacyAndTermsSchema = yup.object({
  privacy: yup
    .string()
    .required("Privacy Policy is required")
    .min(50, "Privacy Policy field cannot have less than 50 symbols."),
  terms: yup
    .string()
    .required("Terms of service is required")
    .min(50, "Terms of service field cannot have less than 50 symbols.")
});
